export default function getInitialState() {
  return {};
}
